export default __webpack_public_path__ + "static/media/iab-step-reward-img.f77ab3b3.svg";